
export interface TwilioError {
  code: number;
  message: string;
  more_info?: string;
  status?: number;
}

export interface ErrorResponse {
  userMessage: string;
  errorType: 'validation' | 'rate_limit' | 'service' | 'authentication' | 'generic';
  canRetry: boolean;
  suggestAlternative?: boolean;
}

export const handleTwilioError = (error: TwilioError): ErrorResponse => {
  switch (error.code) {
    case 60200:
      return {
        userMessage: 'Invalid phone number format. Please include a valid country code (e.g., +1 for US, +44 for UK).',
        errorType: 'validation',
        canRetry: true,
        suggestAlternative: true
      };
    
    case 60203:
      return {
        userMessage: 'Invalid phone number format. Please enter a valid phone number.',
        errorType: 'validation',
        canRetry: true,
        suggestAlternative: true
      };
    
    case 20003:
      return {
        userMessage: 'Authentication failed. Please check your phone number and try again.',
        errorType: 'authentication',
        canRetry: true,
        suggestAlternative: true
      };
    
    case 20429:
      return {
        userMessage: 'Too many verification attempts. Please wait 10 minutes before trying again.',
        errorType: 'rate_limit',
        canRetry: false,
        suggestAlternative: true
      };
    
    case 60202:
      return {
        userMessage: 'This phone number cannot receive SMS messages. Please try a different number.',
        errorType: 'validation',
        canRetry: true,
        suggestAlternative: true
      };
    
    case 20404:
      return {
        userMessage: 'Verification session not found or expired. Please request a new code.',
        errorType: 'service',
        canRetry: true
      };
    
    case 60022:
      return {
        userMessage: 'Invalid verification code. Please check the code and try again.',
        errorType: 'validation',
        canRetry: true
      };
    
    default:
      return {
        userMessage: 'SMS service temporarily unavailable. Please try email verification instead.',
        errorType: 'service',
        canRetry: false,
        suggestAlternative: true
      };
  }
};

export const parseErrorFromResponse = (errorText: string): TwilioError | null => {
  try {
    const parsed = JSON.parse(errorText);
    if (parsed.code && parsed.message) {
      return parsed as TwilioError;
    }
  } catch (e) {
    // Not a JSON error response
  }
  return null;
};
